
import React from 'react'

import HeaderSubmenuItem from './HeaderSubmenuItem'

import './HeaderSubMenu.scss'

interface Props {
  submenu: any
  secondarySubmenu?: any
  projectName?: string
}

const HeaderSubMenu = ({ submenu, secondarySubmenu = [], projectName }: Props) => {

  const primaryItems = submenu.filter((item: any) => !item.alignRight)
  const rightItems = submenu.filter((item: any) => item.alignRight)

  if (!primaryItems.length && !rightItems.length && !secondarySubmenu.length && !projectName) {
    return null
  }

  return (
    <>
      <div className="horizontal-bar-wrap">
        <div className="header-topnav">
          <div className="submenu-bar">
            {(primaryItems.length > 0 || secondarySubmenu.length > 0) && (
              <div className="submenu-left">
                {primaryItems.length > 0 && (
                  <ul className="submenu submenu-primary">
                    {primaryItems.map((item: any, i: number) => (
                      <HeaderSubmenuItem
                        key={i}
                        active={item.active}
                        disabled={item.disabled}
                        icon={item.icon}
                        text={item.text}
                        path={item.path}
                        itemWidth={item.itemWidth}
                      />
                    ))}
                  </ul>
                )}
                {secondarySubmenu.length > 0 && (
                  <ul className="submenu submenu-secondary">
                    {secondarySubmenu.map((item: any, i: number) => (
                      <HeaderSubmenuItem
                        key={i}
                        active={item.active}
                        disabled={item.disabled}
                        icon={item.icon}
                        text={item.text}
                        path={item.path}
                        itemWidth={item.itemWidth}
                      />
                    ))}
                  </ul>
                )}
              </div>
            )}
            <div className="submenu-right">
              {rightItems.length > 0 && (
                <ul className="submenu submenu-settings">
                  {rightItems.map((item: any, i: number) => (
                    <HeaderSubmenuItem
                      key={i}
                      active={item.active}
                      disabled={item.disabled}
                      icon={item.icon}
                      text={item.text}
                      path={item.path}
                      itemWidth={item.itemWidth}
                    />
                  ))}
                </ul>
              )}
              {projectName && (
                <div className={`subtitle${''}`}>
                  {projectName}
                </div>
              )}
              <div className="header-dropdowns" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderSubMenu
